<template>
  <div class="wrapper">
    <h2>Linked Products</h2>
    <template v-if="noSerial">
        <p>
            You do not have a serial number stored yet. Please go to <a href @click.prevent="$router.push('settings')">Settings</a> and enter your Kotobee serial number there.
        </p>
    </template>
    <template v-else>
        <p style="text-align:center">Link your store's ebook products to Kotobee such that paid users can receive immediate access to the ebooks. Select a product from your store to link to Kotobee.</p>
        <div class="productSelect">
            <b-button v-if="!productId" @click="openProductPicker" variant="primary">
                Select a Product
            </b-button>
            <b-input-group v-else :prepend="'Selected Product: ' + productTitle" class="mt-3 productSelectGroup">
                <b-input-group-append>
                    <b-button variant="info" @click="openProductPicker">Change</b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <div class="linking" v-if="productId">
            <div class="linking-tabs">
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Libraries" active>
                            <b-card-text class="tab libraries-tab">
                                <div v-if="resources.libs && (resources.libs.length > 0)">
                                <select v-model="selectedLibraryId">
                                    <option disabled selected value="0">Select a library</option>
                                    <option v-for="library in resources.libs" :value="library.lib.id" :key="library.lib.id">{{library.lib.name}}</option>
                                </select>
                                <br/>
                                <!-- <dropdown :items="resources.libs" v-model="selectedLibraryId" title="Select a library" /> -->

                                <div v-if="selectedLibraryId">
                                    <table>
                                    <tr>
                                        <td>Global access</td>
                                        <td><link-options :item-id="selectedLibraryId" type="libid" /></td>
                                    </tr>
                                    </table>
                                    <resource-linking-table 
                                    v-if="selectedLibrary.roles && (selectedLibrary.roles.length > 0)"
                                    :key="componentUpdateKey+2" title="Roles" :k-items="selectedLibrary.roles" type="rid" />
                                    <resource-linking-table 
                                    v-if="selectedLibrary.categories && (selectedLibrary.categories.length > 0)"
                                    :key="componentUpdateKey+3" title="Categories" :k-items="selectedLibrary.categories" type="catid" />
                                    <resource-linking-table 
                                    v-if="selectedLibrary.libBooks && (selectedLibrary.libBooks.length > 0)"
                                    :key="componentUpdateKey+4" title="Books" :k-items="selectedLibrary.libBooks" type="bid" />

                                </div>
                                </div>
                                <div v-else>
                                    <p>You don't have any libraries.</p>
                                    <p>Create your first library in the <a :href="'https://www.kotobee.com/admin?serial='+serial" target="_blank">Kotobee Admin Portal</a> or through <a href="https://www.kotobee.com/products/author" target="_blank">Kotobee Author</a>.</p>
                                </div>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Cloud Ebooks">
                            <b-card-text class="tab cloudebooks-tab">
                                <div v-if="resources.cloudBooks && (resources.cloudBooks.length > 0)">
                                <resource-linking-table :key="componentUpdateKey" title="" :k-items="resources.cloudBooks" type="cid" />
                                </div>
                                <div v-else>
                                    <p>You don't have any cloud ebooks.</p>
                                    <p>Create your first cloud ebook in the <a :href="'https://www.kotobee.com/admin?serial='+serial" target="_blank">Kotobee Admin Portal</a> or through <a href="https://www.kotobee.com/products/author" target="_blank">Kotobee Author</a>.</p>
                                </div>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
            <b-button @click="submit" variant="primary">Save</b-button>
        </div>
  </div>
</template>

<script>
import {ResourcePicker} from '@shopify/app-bridge/actions';
import { BTabs, BTab, BCard, BButton, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import ResourceLinkingTable from "../elements/ResourceLinkingTable";
import LinkOptions from "../elements/LinkOptions";
import { mapState } from 'vuex'

// import Dropdown from "../elements/Dropdown";

export default {
  name: 'LinkingPage',
  props: {
    title: String,
  },
  components: {
    // Dropdown,
    BTabs, BTab, BCard, BButton, BInputGroup, BInputGroupAppend,
    ResourceLinkingTable, LinkOptions
  },
  data() {
    return {
      noSerial: null,
      serial: "",
      productPicker: null,
    };
  },
  mounted: function() {
    var $scope = this;
    this.$store.dispatch('fetchShopifySettings', function(settings){
        $scope.noSerial = !settings.serial;
        $scope.serial = settings.serial;
        $scope.$store.dispatch('fetchKotobeeResources');
    });
    if (!this.productPicker) {
      //Create a product picker
      this.productPicker = ResourcePicker.create(this.$store.state.bridge, {
        resourceType: ResourcePicker.ResourceType.Product,
        options: {
          actionVerb: ResourcePicker.ActionVerb.Select,
          selectMultiple: false,
        },
      });
      //Subscribe to select event
      this.productPicker.subscribe(ResourcePicker.Action.SELECT, this.changeProduct);
    }

    //get passed product id in URL
    var params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    //params.id will exist if user clicked on "Link to Kotobee" extension
    var selectedId = params.id;
    if(selectedId)
        this.$store.dispatch('getProduct', {product_id:selectedId, callback:function(res){
            var product = res.product;
            var access = res.access;
            product.id = "gid://shopify/Product/"+product.id;
            $scope.$store.commit('setSelectedProductAccess', access);
            $scope.changeProduct({selection:[product]});
        }});

  },
  computed: {
    selectedLibraryId: {
      get() { return this.$store.state.selectedLibId},
      set(id) {this.$store.commit('selectLib', id)}
    },
    ...mapState({
      productId: 'selectedProductId',
      productTitle: 'selectedProductTitle',
      componentUpdateKey(state) {
          return this.productId + state.selectedLibId;
      },
      selectedLibrary(state) {
        const kLibs = state.kotobeeResources.libs;
        let selected = {};

        if (kLibs && kLibs.length) {
          for (let i = 0; i < kLibs.length; i++) {
            const lib = kLibs[i];
            if (lib.lib.id == this.selectedLibraryId) {
              selected = lib;
              break;
            }
          }
        }
        return selected;
      },
      resources(state) {
        return state.kotobeeResources;
      },
    })
  },
  methods: {
    openProductPicker() {
      this.productPicker.dispatch(ResourcePicker.Action.OPEN);
    },
    changeProduct({selection}) {
        console.log("changeProduct",selection);
        if (selection.length) {
          this.$store.dispatch('changeSelectedProduct', selection[0]);
        }
    },
    submit() {
        console.log("submit clicked");
        this.$store.dispatch('submitModifiedAccess', function() {
        console.log("success");
        window.JSAlert.alert("Updated successfully", null, window.JSAlert.Icons.Success);
      });
    }
    
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
    text-align: left;
}
select{
    padding: 3px 8px;
    margin-bottom: 10px;
}
.wrapper {
  width: 100%;
  text-align: center;
}
.productSelect {
  text-align: center;
}
.productSelectGroup {
  align-items: center;
  justify-content: center;
}
table {
  width: 100%;
  text-align: center;
}
td {
  width: 50%;
}
h2 {
  margin: 20px 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.linking-tabs {
  margin: 20px;
}
.tab-pane{
    overflow-y: auto;
    max-height: 600px;
}
</style>
